import { OrderRequestWashType } from '../models/notification-order-request.models';

export function normalizeOrderRequestWashType(washType: string): OrderRequestWashType {
  const normalized = washType.toLowerCase().trim().replace(/[\s-]+/g, '_');
  if (normalized === 'add_on') {
    return 'add_on';
  }
  if (normalized === 'single_wash' || normalized === 'single') {
    return 'single_wash';
  }
  if (
    normalized === 'monthly_membership' ||
    normalized === 'monthly' ||
    normalized === 'subscription' ||
    normalized === 'membership'
  ) {
    return 'monthly_membership';
  }
  return 'single_wash';
}
